import addressSaga from '~/sagas/address/address.saga';

export default addressSaga;
